import React, { memo } from "react";
import TextField from "@mui/material/TextField";

const TextAreaField = memo(({
    id = "",
    label = "",
    value = "",
    type = "text",
    size = "normal",
    onChange = () => {},
    onBlur = () => {},
    error = "",
    helperText = "",
    className = "",
    marginTop = "5px",
    sx = {},
    required = false,
    fullWidth = true,
    ...otherProps
}) => {
    return (
        <TextField
            variant="outlined"
            fullWidth={fullWidth}
            label={label}
            type={type}
            value={value}
            onChange={(e) => onChange(e.target.value, e)}
            error={error == true}
            helperText={helperText}
            className={className}
            sx={{
                "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-disabled": {
                    color: "#252525",
                },
                "& fieldset": {
                    borderRadius: 0,
                },
                marginTop,
                ...sx,
            }}
            size={size}
            required={required}
            {...otherProps}
        />
    );
});

export default TextAreaField;
